import { Request as BaseRequest } from '@vodafoneis/sjonvarpskjarni-js-lib';

export default class Request extends BaseRequest {}
